// @flow
import * as Sentry from '@sentry/browser';
window.bizomWeb = {};

export const setLocalStorage = (name, value) => {
  localStorage.setItem(name, value);
};

export const setSessionStorage = (name, value) => {
  try {
    localStorage.setItem(name, value);
  } catch (err) {
    window.bizomWeb[name] = value;
  }
};

export const getSessionVal = name => {
  try {
    return localStorage.getItem(name);
  } catch (err) {
    return window.bizomWeb[name];
  }
};

export const rmApplicationStr = () => {
  try {
    localStorage.clear();
    sessionStorage.clear();
  } catch (err) {
    window.bizomWeb = {};
  }
};

export const setdisableHandler = (mode, newadd) => {
  if (mode === 'new' || newadd === true) return false;
  else return true;
};

export const LogError = (msg, err) => {
  if (process.env.NODE_ENV === 'production') {
    Sentry.captureException(msg + ':::' + err);
  }
  console.error(msg + ':::' + err);
};

export const reLoadMainHandler = () => {
  try {
    localStorage.clear();
    sessionStorage.clear();
  } catch (err) {
    window.bizomWeb = {};
  } finally {
    window.parent.postMessage('reloadWindow', '*');
    return false;
  }
};

export const istToyymmddHandler = param => {
  try {
    let date = new Date(param.replace('IST', ''));
    let day = date.getDate();
    let month = date.getMonth();
    let year = date.getFullYear();
    let datetemp = new Date(year, month, day);
    let result = datetemp.toLocaleDateString('en-GB', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
    result = result.split('/');
    let newFormat = result[0] + '-' + result[1] + '-' + result[2];
    return newFormat;
  } catch (e) {
    console.error('issue in date change format::' + e);
  }
};

export const isValidInput = str => {
  //eslint-disable-next-line
  return !/[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(str);
};

export const getErrorMessageHandler = code => {
  let text;
  const statudCode = code;

  switch (statudCode) {
    case 400:
      text = 'The request cannot be processed, as parameter are not valid';
      break;
    case 404:
      text = 'The requested resource could not be found';
      break;
    case 408:
      text = 'The server timed out waiting for the request.';
      break;
    case 500:
      text =
        'The server encountered an unexpected condition that prevented it from fulfilling the request.';
      break;
    default:
      console.error(`Something went wrong!!!`);
  }
  return text;
};

export const getDateHandler = (dateString, separator = '-') => {
  const roundNum = num => (num < 10 ? `0${num}` : num);

  let dateObj = new Date(dateString);
  let month = dateObj.getUTCMonth() + 1;
  let day = dateObj.getUTCDate();
  let year = dateObj.getUTCFullYear();
  let newdate = roundNum(day) + separator + roundNum(month) + separator + year;
  return newdate;
};

export function convertDateYYYYMMDD(str) {
  var date = new Date(str),
    mnth = ('0' + (date.getMonth() + 1)).slice(-2),
    day = ('0' + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join('-');
}

export const changeHierarchyFormat = res => {
  const keys = Object.keys(res?.userHierarchy);
  const values = Object.values(res.userHierarchy);
  let arr = keys.map((key, i) => {
    return { id: key, hierarchy: values[i] };
  });
  arr = arr.map(el => {
    if (!el.hierarchy) {
      return el;
    } else {
      const hierarchyNew = el.hierarchy;
      const keys = Object.keys(hierarchyNew);
      let h = keys.map((key, i) => ({ ...hierarchyNew[key], isActive: 1 }));
      return { id: el.id, hierarchy: h };
    }
  });
  return arr;
};

export const findDuplicates = arr => {
  let sorted_arr = arr.slice().sort();
  let result = [];
  for (let i = 0; i < sorted_arr.length - 1; i++) {
    if (sorted_arr[i + 1] === sorted_arr[i]) {
      result.push(sorted_arr[i]);
    }
  }
  return result;
};

export const getBrowserName = () => {
  let isChromium = window.chrome;
  let winNav = window.navigator;
  let vendorName = winNav.vendor;
  let isOpera = typeof window.opr !== 'undefined';
  let isIEedge = winNav.userAgent.indexOf('Edg') > -1;

  if (
    isChromium !== null &&
    typeof isChromium !== 'undefined' &&
    vendorName === 'Google Inc.' &&
    isOpera === false &&
    isIEedge === false
  ) {
    return 'Chrome';
  } else {
    return 'Other';
  }
};

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
export function getMonth(m) {
  return months[m - 1];
}

export const setSelectValue = (key, object = {}) =>
  key ? { value: key, label: object[key] } : null;

export const includesDuplicates = arr => {
  let setArr = [...new Set(arr)];
  return arr.length !== setArr.length;
};
export const capitalizeWords = str => {
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

// this function checks if a string contains numbers, captial letters, spaces or special characters
export const checkForSpecialString = str => {
  const hasSpace = /\s/.test(str);
  const hasNumber = /\d/.test(str);
  const hasSpecialCharacter = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(str);
  const hasCapitalLetter = /[A-Z]/.test(str);
  return hasSpace || hasNumber || hasSpecialCharacter || hasCapitalLetter;
};

// Function to check if the desired key exists with the desired value in the array of JSON objects
export const keyExistsWithValue = (arr, key, value) => {
  for (const obj of arr) {
    if (obj.hasOwnProperty(key) && obj[key] === value) {
      return true; // Key with desired value exists
    }
  }
  return false; // Key with desired value does not exist
}

//function to json arr into single values array
export const covertInArr = (jsonArray, key)=> {
  let newARR = [];
  jsonArray.forEach((ele)=>{     
    if(ele.hasOwnProperty(key))
    {
      newARR.push(ele.value);
    }else{
      newARR.push(ele);
    }
  });
  return newARR;
};

// Validation :: For alphanumeric and special characters
// Constant for allowed special characters error message
export const ALLOWED_SPECIAL_CHARS_ERROR_MESSAGE = 
  "Only alphanumeric and special characters (. / ' \\ - _ , space ( )) are allowed";

// Constant for allowed special characters list (for display purposes)
export const ALLOWED_SPECIAL_CHARS_LIST = [
  '.',  // Dot/Period/Full stop
  '/',  // Forward slash
  "'",  // Apostrophe/Single quote
  '\\', // Backslash
  '-',  // Hyphen/Dash
  '_',  // Underscore
  ',',  // Comma
  ' ',  // Space/Whitespace
  '(',  // Opening parenthesis
  ')'   // Closing parenthesis
];

export const isValidInputWithAllowedSpecialChars = str => {
  // Regex pattern that allows:
  // - Alphanumeric characters (a-z, A-Z, 0-9)
  // - Allowed special characters: . / ' \ - _ , (space) ( )
  const allowedPattern = /^[a-zA-Z0-9./'\\,\-_ ()]*$/;
  return allowedPattern.test(str);
};

/**
 * Validates if a string contains ONLY the allowed special characters (no other characters)
 * @param {string} str - The string to validate
 * @returns {boolean} - Returns true if valid
 */
export const hasOnlyAllowedSpecialChars = str => {
  if (!str || str.length === 0) return true;
  // This checks if there are any characters NOT in the allowed list
  const disallowedPattern = /[^a-zA-Z0-9./'\\,\-_ ()]/g;
  return !disallowedPattern.test(str);
};

/**
 * Removes all characters except alphanumeric and allowed special characters
 * @param {string} str - The string to sanitize
 * @returns {string} - Sanitized string
 */
export const sanitizeInputWithAllowedChars = str => {
  if (!str) return '';
  // Keep only allowed characters
  return str.replace(/[^a-zA-Z0-9./'\\,\-_ ()]/g, '');
};

